<app-header></app-header>
<div class='govpl-spacer'></div>
<main>
  <div class='main-container'>
    <ng-content></ng-content>
  </div>
</main>
<app-footer>
</app-footer>
